export default __webpack_public_path__ + "static/media/care.6505157b.jpg";